module.exports = __webpack_public_path__ + "static/media/desktopScreenshot05.96794479.jpg";